var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeActiveMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 24,
    viewBox: "0 0 44 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 24,
    rx: 12,
    fill: "#E9F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6719 10.5623L22.4219 4.88261C22.3067 4.77721 22.1562 4.71875 22 4.71875C21.8438 4.71875 21.6933 4.77721 21.5781 4.88261L15.3281 10.5623C15.2652 10.6217 15.2149 10.6931 15.18 10.7722C15.1451 10.8514 15.1264 10.9367 15.125 11.0232V18.2498C15.125 18.4156 15.1908 18.5745 15.3081 18.6917C15.4253 18.809 15.5842 18.8748 15.75 18.8748H28.25C28.4158 18.8748 28.5747 18.809 28.6919 18.6917C28.8092 18.5745 28.875 18.4156 28.875 18.2498V11.0232C28.8736 10.9367 28.8549 10.8514 28.82 10.7722C28.7851 10.6931 28.7348 10.6217 28.6719 10.5623Z",
    stroke: "#2B6CB0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActiveMobile);
export default __webpack_public_path__ + "static/media/homeActiveMobile.a624a4303940e6a04c9732fa58a9d466.svg";
export { ForwardRef as ReactComponent };